import {
  IBundleCoinBalance,
  COIN_FULL_NAME,
  ICryptoBundle,
  ICryptoPortfolio,
  ICryptoPrices,
} from './../../../../../models/Crypto';
import { Component, Input, OnInit } from '@angular/core';
import { CryptoService } from 'src/app/pages/core/abstraction/crypto.service';
import { AuthService } from 'src/app/pages/core/abstraction/auth.service';

@Component({
  selector: 'app-bundle-balance',
  templateUrl: './bundle-balance.component.html',
  styleUrls: ['./bundle-balance.component.scss'],
})
export class BundleBalanceComponent implements OnInit {
  @Input() ticker: string;
  @Input() coinsAmounts: { amount: string; weiAmount: string }[];
  @Input() currency: string;
  @Input() equivalentInArs: boolean;
  coins: string[];
  cryptoBalances: ICryptoPortfolio[] = [];
  bundleData: ICryptoBundle;
  bundleCoins: IBundleCoinBalance[];
  variation: number;
  price: number;
  cryptoPrices: ICryptoPrices;
  name: string;
  isOpen = false;

  constructor(public cryptoService: CryptoService, private authService: AuthService) {}

  ngOnInit(): void {
    this.cryptoService.bundlesVariations.subscribe((res) => {
      if (res.variations) {
        this.variation = res?.variations?.weekly[this.ticker];
      }
    });
    this.cryptoService.cryptoBundles.subscribe((bundles) => {
      this.name = bundles.find((bundle) => bundle.ticker === this.ticker)?.name;
      this.coins = bundles
        .find((bundle) => bundle.ticker === this.ticker)
        ?.coins.map((coin) => coin.ticker);
    });
    this.getCryptoPortfolio();
  }

  getCryptoPortfolio() {
    for (const crypto in this.coinsAmounts) {
      const coinTicker = crypto;
      this.cryptoBalances.push({
        ticker: coinTicker,
        name: COIN_FULL_NAME[coinTicker],
        price: '0',
        porcentage: 0,
        stocks: this.coinsAmounts[coinTicker]?.amount || '0',
        balance: '0',
        balanceArs: '0',
        stakeBalance: 0,
        totalARSinvested: 0,
        capitalChange: 0,
        capitalChangeP: 0,
        histories: [],
      });
    }
  }

  getBundleTotalFiat() {
    return this.cryptoService.getFiatValueByBundle(this.ticker, this.currency);
  }
}
